import AlienIcon from '../../icons/Alien';
import BrainBotIcon from '../../icons/BrainBot';
import CoinIcon from '../../icons/Coin';
import CrashGuardIcon from '../../icons/CrashGuard';
import EnergyCapacityIcon from '../../icons/EnergyCapacity';
import UFOIcon from '../../icons/UFO';
import BaseBoostStar from '../../assets/svg/boosters/item-icon-backgrounds/base_boost.svg';
import Coin from '../../assets/svg/boosters/coin.svg';
import BrainStar from '../../assets/svg/boosters/item-icon-backgrounds/brain-star.svg';
import Brain from '../../assets/svg/boosters/brain.svg';
import EnergyStar from '../../assets/svg/boosters/item-icon-backgrounds/energy-star.svg';
import Energy from '../../assets/svg/boosters/energy.svg';
import DoubleStar from '../../assets/svg/boosters/item-icon-backgrounds/double-star.svg';
import Double from '../../assets/svg/boosters/ufo-without-bg.svg';
import CrashStar from '../../assets/svg/boosters/item-icon-backgrounds/crash-star.svg';
import Crash from '../../assets/svg/boosters/crash.svg';
import LuckyStar from '../../assets/svg/boosters/item-icon-backgrounds/lucky-star.svg';
import Lucky from '../../assets/svg/boosters/lucky.svg';
import { MultiColorIconProps } from '../../types/icons';

const getBoostersItemIcon = (type: string, iconProps?: MultiColorIconProps) => {
  switch (type) {
    case 'coin':
      return <CoinIcon {...iconProps} />;
    case 'brain-bot':
      return <BrainBotIcon {...iconProps} />;
    case 'ufo':
      return <UFOIcon {...iconProps} />;
    case 'crash-guard':
      return <CrashGuardIcon {...iconProps} />;
    case 'energy':
      return <EnergyCapacityIcon {...iconProps} />;
    case 'alien':
      return <AlienIcon {...iconProps} />;
    default:
      return <CoinIcon {...iconProps} />;
  }
};

export default getBoostersItemIcon;

export const getBoosterCardIcons = (type: string) => {
  switch (type) {
    case 'coin':
      return {
        star: <img src={BaseBoostStar} alt="BaseBoostStar-icon" className="w-full h-full" />,
        icon: <img src={Coin} alt="coin" className="w-full h-full" />,
      };
    case 'brain-bot':
      return {
        star: <img src={BrainStar} alt="brain-star" className="w-full h-full" />,
        icon: <img src={Brain} alt="brain-icon" className="w-full h-full" />,
      };
    case 'ufo':
      return {
        star: <img src={DoubleStar} alt="double-star" className="w-full h-full" />,
        icon: <img src={Double} alt="double-icon" className="w-full h-full" />,
      };
    case 'crash-guard':
      return {
        star: <img src={CrashStar} alt="crash-star" className="w-full h-full" />,
        icon: <img src={Crash} alt="crash-icon" className="w-full h-full" />,
      };
    case 'energy':
      return {
        star: <img src={EnergyStar} alt="energy-star" className="w-full h-full" />,
        icon: <img src={Energy} alt="energy-icon" className="w-full h-full" />,
      };
    case 'alien':
      return {
        star: <img src={LuckyStar} alt="lucky-star" className="w-full h-full" />,
        icon: <img src={Lucky} alt="lucky-icon" className="w-full h-full" />,
      };
    default:
      return {
        star: <img src={DoubleStar} alt="double-star" className="w-full h-full" />,
        icon: <img src={Double} alt="double-icon" className="w-full h-full" />,
      };
  }
};
